import { type HttpInterceptorFn } from '@angular/common/http';
import {
  correlationInterceptor,
  idempotencyInterceptor,
  credentialsInterceptor,
  csrfInterceptor,
} from './request-interceptors';
import { errorInterceptor, refreshInterceptor } from './session-interceptors';

/**
 * The interceptor chain, outermost first. The order carries meaning:
 *
 *   1. error        sees the FINAL outcome, after any refresh and replay
 *   2. idempotency  one key per logical write, so a refresh replay reuses it
 *   3. refresh      replays a 401 once; sits outside CSRF so the replay re-reads the cookie
 *   4. correlation  one id per attempt
 *   5. credentials  send the session cookies
 *   6. csrf         copy the CSRF cookie into its header
 *
 * Responses travel the list in reverse, which is why error handling is first.
 */
export const HTTP_INTERCEPTORS_IN_ORDER: readonly HttpInterceptorFn[] = [
  errorInterceptor,
  idempotencyInterceptor,
  refreshInterceptor,
  correlationInterceptor,
  credentialsInterceptor,
  csrfInterceptor,
];
